export default __webpack_public_path__ + "KaTeX_Math-BoldItalic.94810ff68bb3c9cb6d3e9f3e73001b4e.woff";